<template>
	<div class="list-card">
		<div class="half-top">
			<avatar :isTeam="isTeam" :image="data.image" :width="width" :style="{ 'margin': avatarMargin }" @click="onAvatarClick"></avatar>

			<div class="name-wrap">
				<div class="kana">{{ data.name_kana }}</div>
				<div class="name bold18">{{ data.name }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import Avatar from '@/components/Avatar'

export default {
	name: 'ListCard',
	components: {
		Avatar,
	},
	props: {
		data: {
			type: Object,
			default: null,
		},
		isTeam: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	computed: {
		width: function() {
			return !this.isTeam ? 150 : 160;
		},
		avatarMargin: function() {
			return !this.isTeam ? '5px' : '0';
		},
	},
	methods: {
		onAvatarClick: function() {
			this.$emit('avatar-click', this.data.id);
		},
	},
}
</script>

<style lang="scss">

</style>
